module.exports = __webpack_public_path__ + "img/MutantLightArmor.59a60dcd.gif";